import { render, staticRenderFns } from "./EditDeleteChallengeModal.vue?vue&type=template&id=e78dbf66&scoped=true&"
import script from "./EditDeleteChallengeModal.vue?vue&type=script&lang=js&"
export * from "./EditDeleteChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDeleteChallengeModal.vue?vue&type=style&index=0&id=e78dbf66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78dbf66",
  null
  
)

export default component.exports